import { useKeyboardHandler } from "./keyboard"
import { Query, useQuery } from "./query"

const listStyle: React.CSSProperties = {
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    margin: 0,
    padding: 0,
    listStyle: "none"
}


interface SharedProps<T> {

    text: string

    textSelector(item: T): string
    keySelector(item: T): string | number

    close(): void

    applyFilter: boolean

    selected: T
    setSelected(item: T | undefined): void

    header?: React.ReactNode
    footer?: React.ReactNode
    noMatch?: React.ReactNode

    matchContent?(item: T): React.ReactNode

}

type Props<T> = SharedProps<T> & Query<T>

export function QueryResults<T>(props: Props<T>) {

    const { textSelector, keySelector, text, close, selected, setSelected, matchContent } = props

    const results = useQuery(props, text)

    const [focusedIndex, setFocusedIndex] = React.useState(-1)

    const listRef = React.useRef<HTMLUListElement>(null)

    React.useEffect(() => {

        setFocusedIndex(
            (selected && results)
                ? results.findIndex(s => s === selected)
                : 0
        )

    }, [selected, results])

    React.useEffect(() => {

        if (listRef.current && (focusedIndex >= 0)) {
            const li = listRef.current.children[focusedIndex] as HTMLLIElement
            if (li) {
                li.scrollIntoView({ block: "center" })
            }
        }

    }, [listRef, results, focusedIndex])

    useKeyboardHandler(true, {
        close,
        items: results,
        focusedIndex: focusedIndex,
        setFocusedIndex: setFocusedIndex,
        select(index: number) {

            index = index < 0
                ? results.length === 1 ? 0 : -1
                : index

            if (index >= 0) {
                setSelected(results![index])
            }

            close()

        }
    })

    if (results === undefined) {
        return null
    }

    if (results.length === 0) {
        return null
    }

    function onClick(item: T) {
        setSelected(item)
        close()
    }

    return <>

        {
            props.header
        }

        <ul ref={listRef} className="results" style={listStyle}>
            {results.map((s, index) =>

                <li
                    key={keySelector(s)}
                    className={selected === s
                        ? "selected"
                        : (index === focusedIndex)
                            ? "focused"
                            : undefined
                    }
                >
                    <button
                        type="button"
                        onMouseDown={e => e.preventDefault()}
                        onClick={() => onClick(s)}
                    >
                        {
                            matchContent
                                ? matchContent(s)
                                : textSelector(s)
                        }
                    </button>
                </li>)}
        </ul>

        {
            props.footer
        }

    </>


}
